import { render } from "./UserAccountManager.vue?vue&type=template&id=6faf25de&scoped=true"
import script from "./UserAccountManager.vue?vue&type=script&lang=js"
export * from "./UserAccountManager.vue?vue&type=script&lang=js"

import "./UserAccountManager.vue?vue&type=style&index=0&id=6faf25de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faf25de"]])

export default __exports__